import type { SVGProps } from 'react';
const arrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M15.6472 4.46978L15.7178 4.53217L22.4678 11.2822C22.7382 11.5525 22.759 11.978 22.5302 12.2722L22.4678 12.3428L15.7178 19.0928C15.4249 19.3857 14.9501 19.3857 14.6572 19.0928C14.3868 18.8225 14.366 18.397 14.5948 18.1028L14.6572 18.0322L20.1262 12.5625H2.4375C2.02329 12.5625 1.6875 12.2267 1.6875 11.8125C1.6875 11.4279 1.97703 11.1109 2.35003 11.0675L2.4375 11.0625H20.1262L14.6572 5.59283C14.3868 5.32247 14.366 4.89704 14.5948 4.60283L14.6572 4.53217C14.9275 4.26181 15.353 4.24101 15.6472 4.46978Z"
      fill={props.color ?? 'black'}
      fillRule="evenodd"
    />
  </svg>
);
export default arrowRight;
